import { styled } from '@mui/material/styles';
import { TableCell } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	fontSize: '12px',
	padding: '12px 4px',
}));

export default StyledTableCell;
